import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { p13nSelector } from 'selectors/p13n/p13nSelector';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';
import Empty from 'constants/empty';
import PersonalizationUtils from 'utils/Personalization';
import sysUtils from 'utils/ShopYourStore';
import { headerAndFooterSelector } from 'selectors/headerAndFooter/headerAndFooterSelector';
import { showSearchDropdownBuyItAgainSelector } from 'viewModel/selectors/testTarget/showSearchDropdownBuyItAgainSelector';

const { getMegaNavPersonalizedComponent } = PersonalizationUtils;
const { wrapHOC } = FrameworkUtils;
const fields = createSelector(
    p13nSelector,
    coreUserDataSelector,
    (_state, ownProps) => ownProps.headerFooterContent,
    (_state, ownProps) => ownProps.personalization,
    headerAndFooterSelector,
    showSearchDropdownBuyItAgainSelector,
    (p13n, user, headerFooterContent, personalization, headerAndFooter, showSearchDropdownBuyItAgain) => {
        const isShopYourStoreEnabled = sysUtils.shopYourStoreEnabled();
        let personalizedComponent = Empty.Array;

        // Skip personalization for SEO bots - render static menu from CMS
        if (!Sephora.isNodeRender && !Sephora.isSEO && Sephora.Util.InflatorComps.services.loadEvents.HydrationFinished) {
            personalizedComponent = getMegaNavPersonalizedComponent(p13n, personalization, user);
        }

        const navItems = personalizedComponent?.variationData?.items || headerFooterContent?.megaNav?.items || Empty.Array;
        const menuItems = [...navItems];
        const showNewBadge = isShopYourStoreEnabled && !sysUtils.shopYourStoreV2Enabled();

        return {
            menuItems,
            user,
            p13n,
            isCompact: headerAndFooter.isCompact,
            isShopYourStoreEnabled,
            showNewBadge,
            showSearchDropdownBuyItAgain
        };
    }
);
const withHeaderProps = wrapHOC(connect(fields));

export {
    fields, withHeaderProps
};
